import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"background-color":"lightgrey"},
  class: "d-flex"
}
const _hoisted_2 = { class: "col pb-2 px-3 d-flex flex-column" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "m-0" }, "Notice", -1)
const _hoisted_4 = { class: "p-3 d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (!_ctx.noticeAcknowledged && _ctx.message && _ctx.message.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_ctx.message), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            label: "Close",
            icon: "pi pi-times",
            iconPos: "left",
            onClick: _ctx.acknowledgeNotice
          }, null, 8, ["onClick"])
        ])
      ]))
    : _createCommentVNode("", true)
}